import React, {useEffect, useState, useRef } from 'react';
import { Space, Table, Tag ,Modal } from 'antd';
import {
    Layout,
    Input,
    Button,
    Drawer,
    Tabs,
    Form,
    Checkbox,
    Radio,
    Select,
    RadioChangeEvent,
    Spin
} from 'antd';
import {
    PlusOutlined,
    CloseOutlined
} from '@ant-design/icons';
import './index.less';
import moment from 'moment';
import HeaderSearch from '@/components/HeaderSearch';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux';
import {
    addUsersAction,
    sendWelcomeEmailListAction,
    updateUserAction,
} from '@/redux/reducer/agrialertUser';
import {
    getUserList,
    searchUserInformation,
    addUsers,
    sendWelcomeEmail,
    updateUser,
    userManagementGetCurrentUserInfo,
    getAllRoles,
    deleteAgriAlertUsers,
    checkIfUserHaveTemplate,
    transferTemplatesToUser,
    getAgriAlertAdminPublisherUsers,
    checkIfUserHaveSubscription
} from '@/util/Request/agrialert';
import {
    IUserManagementAddUsersRequestModel,
    IUserManagementeSendWelcomeEmailrRequestModel,
    IUserManagementeUpdateUserRequestModel,
    IUserManagementeDeleteUserRequestModel,
} from '@/util/Request/agrialert/requestType';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import {
    AgrialertUserManagementEditSvg,
    AgrialertUserManagementDeleteSvg,
    AgrialertUserManagementSuccessSvg
} from '@/resource/IconComponentSets';
import IF from '@/components/IF';
import HeaderSearchAgrialert from '@/components/HeaderSearchAgrialert';
import { updateCurrentRoleId, updateTab, updateTemplateType } from '@/redux/reducer/agrialertTemplate';
import { TemplateEnumType } from '@/util/Request/agrialert/responseType';
import { useNavigate } from 'react-router-dom';
const { Content } = Layout;
const { Option } = Select;

export default function UserManagement() {
    const navigate = useNavigate();
    const currentUserId = useSelector((state: RootState) => state.agrialertTemplate.currnetUserId);
    const { deleteFiled } = useSelector((state: RootState) => state.commonData);
    const [form] = Form.useForm();
    const home = useRef(null);
    //When Administer add a new user, he can decide if inviation mail is needed or not,
    //if (sendInvitationEmail == true) means send Invitation Email
    const [sendInvitationEmail, setSendInvitationEmail] = useState<boolean>(false);
    const onChangeSend = (e: CheckboxChangeEvent) => {
        console.log('3333checkis:',`checked = ${e.target.checked}`);
        console.log('check:',typeof(e.target.checked));
        setSendInvitationEmail(e.target.checked);
    };
    //get searchUser's parameter
    const [displayName, setdisplayName] = useState('');
    const [mail, setmail] = useState('');
    const [userID, setUserID] = useState('');
    const [givenName, setGivenName] = useState('');
    const [searchText, setSearchText] = useState<string>('');
    const [spining, setSpining] = useState(false);
    const onChanges = (value: string) => {
        console.log('select name', value);
        searchUserInformations.forEach(function (item) {
            if (item.displayName === value) {
                setdisplayName(value);
                setmail(item.mail);
                setUserID(item.onPremisesExtensionAttributes.extensionAttribute1);
                setGivenName(item.givenName);
            }
        });
    };

    const [mailForDelete, setmailForDelete] = useState('');
    const [userIDForDelete, setUserIDForDelete] = useState('');
    const onChangesForDelete = (value: string) => {
        console.log('selected $onChangesForDelete}', value);
        searchUserInformationsForDelete.forEach(function (item) {
            if (item.userDisplayName === value) {
                setmailForDelete(item.userEmail);
                setUserIDForDelete(item.userId);
            }
        });
    };
    //get serachUservalue
    const [serachUservalue, setSerachUservalue] = useState('');
    //Drawer
    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        dispatch({
            type: 'common/closeDownFile'
        });
        setVisible(true);
    };
    const onClose = () => {
        form.resetFields();
        setmail('');
        setSelectedRole(null);
        setVisible(false);
        setdisplayName(undefined);
        setUserID('');
        setSendInvitationEmail(false);
    };
    const [visible2, setVisible2] = useState(false);
    const onClose2 = () => {
        setVisible2(false);
    };
    const [userIDUpdate, setUserIDUpdate] = useState('');
    const [roleIDUpdate, setRoleIDUpdate] = useState<number>(null);
    const [newRoleIDUpdate, setNewRoleIDUpdate] = useState<number>(null);
    const [userIsActiveUpdate, setUserIsActiveUpdate] = useState(true);
    const [userDisplayNameUpdate, setUserDisplayNameUpdate] = useState('');
    const [userEmailUpdate, setUserEmailUpdate] = useState('');
    const [searchUserInformations, setSearchUserInformations] = useState([]);
    const [seaParam,setSeahParam] = useState<string>('');
    const [firstIn, setFirstIn] = useState(true);
    const [lock, setLock] = useState(false);
    const [currentStatus, setCurrentStatus] = useState<string>('All');
    useEffect(() => {
        if (!firstIn) {
            GetAnalyses(seaParam, pageIndex, currentStatus);
        }
    }, [deleteFiled]);

    const GetAnalyses = async (param=seaParam,page=pageIndex, localCurrentStatus?: string)=>{
        try {
            if(lock) {
                return;
            }
            setLock(true);
            setSeahParam(param);
            setLock(false);
            if (firstIn) {
                setFirstIn(false);
            }
            setIsFetching(false);
        } catch(err) {
            setIsFetching(false);
            setLock(false);
            if (firstIn) {
                setFirstIn(false);
            }
        }
    };
    const editItem = (param) => {
        console.log('deleteeditItem:',param);
        dispatch({
            type: 'common/closeDownFile'
        });
        setVisible2(true);
        setUserIDUpdate(param.userId);
        setRoleIDUpdate(param.roleId);
        if (param.roleId == null)
        {
            setNewRoleIDUpdate(null);
        }
        else
        {
            setNewRoleIDUpdate(param.roleId);
        }
        setUserIsActiveUpdate(param.userIsActive);
        setUserDisplayNameUpdate(param.userDisplayName);
        setUserEmailUpdate(param.userEmail);
    };
    //table columns
    const columns = [
        {
            title:'Name of the User',
            dataIndex: 'userDisplayName',
            width: '350px',
            render: (text, record, index) => <div>{text}</div>
        },
        {
            title: 'Email ID',
            dataIndex: 'userEmail',
            render: (text) => <span>{text}</span>
        },
        {
            title: 'Role',
            dataIndex: 'roleName',
            filters: [
                {
                    text: 'Administrator',
                    value: 'Administrator',
                },
                {
                    text: 'Publisher',
                    value: 'Publisher',
                },
                {
                    text: 'Reader',
                    value: 'Reader',
                },
            ],
            onFilter: (value, record) => record.roleName.startsWith(value as string)
        },
        {
            title:'Status',
            dataIndex: 'userIsActive',
            render: (_, { userIsActive }) => {
                let color: string;
                let staus: string;
                if (userIsActive) {
                    color = 'activecircle';
                    staus = 'Active';
                } else {
                    color = 'inactivecircle';
                    staus = 'Inactive';
                }
                return (
                    <div className='status-div'>
                        <div className={color} key={userIsActive}></div>
                        {staus}
                    </div>
                );
            },
            filters: [
                {
                    text: 'Active',
                    value: 'Active',
                },
                {
                    text: 'Inactive',
                    value: 'Inactive',
                }
            ],
            onFilter: (value, record) => (record.userIsActive==true?'Active':'Inactive').startsWith(value as string)
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            render: (text, record, index) => <Button className='edit-button-style' onClick={e => editItem(record)} icon={<AgrialertUserManagementEditSvg />}>
                <span className='edit-span-style'>Edit</span>
            </Button>,
        },
    ];

    useEffect(() => {
        getUserLists();
    }, [deleteFiled]);

    //addUser callback
    const [roleID, setroleID] = useState(3);
    const [selectedRole,setSelectedRole]=useState(null);
    const callback = async (key) => {
        console.log('tabKeytabKeytabKey', key);
        setroleID(key);
        setSelectedRole(key);
    };
    //updateUser callbackEdit
    const callbackEdit = async (key) => {
        setNewRoleIDUpdate(key);
        setRoleIDUpdate(key);
    };
    const success = () => {
        addUsersActionU();
        onClose();
    };
    const [refreshFlag, setRefreshFlag] = useState(0);
    const success2 = () => {
        updateUserU();
        onClose2();
    };
    useEffect(() => {
        if (refreshFlag != 0) {
            console.log('cc ', refreshFlag);
            getUserLists();
        }
    }, [refreshFlag]);
    //search
    const searchKeyDown = async (e) => {
        console.log(e);
        setSearchText(e);
        getUserLists(e);
    };
    //tabPosition
    const [tabPosition, setTabPosition] = useState('');
    useEffect(() => {
        //console.log('dd userIsActiveUpdate', userIsActiveUpdate);
        if (userIsActiveUpdate === true) {
            // console.log('dd tabPosition a', tabPosition);
            setTabPosition('true');
        } else {
            // console.log('dd tabPosition b', tabPosition);
            setTabPosition('false');
        }
    }, [userIsActiveUpdate]);
    const changeTabPosition = (e: RadioChangeEvent) => {
        //console.log('active and inactive', e.target.value);
        if (e.target.value == 'true') {
            setTabPosition('true');
            setUserIsActiveUpdate(true);
        } else {
            setTabPosition('false');
            setUserIsActiveUpdate(false);
        }
    };
    //=================  define dispatch and get value from store ===================
    const dispatch = useDispatch();
    //const { userList} = useSelector((state: RootState) => state.userManagemnetPageData);
    const [pageIndex, setpageIndex] = useState<number>(1);
    const [desc, setDesc] = useState(false);
    //getUser API
    const [userList, setData] = useState([] as any);
    const getUserLists = async (param = searchText, page = pageIndex) => {
        console.log('searchTextsearchText', searchText);
        console.log('pageIndexpageIndex', pageIndex);
        try {
            const res = await getUserList({
                searchText: param,
                pageIndex: 0,
                pageSize: 30 * page,
                isGetAllUsers: false,
                isSortByNameDesc: false,
                module:'agri alert'
            });
            setData(res);
            setIsFetching(false);
        } catch (err) {
            setIsFetching(false);
        }
    };
    useEffect(() => {
        getUserLists();
    }, [desc]);

    useEffect(() => {
        getUserLists();
        searchUserInformationAction();
        searchUserInformationForDeleteAction();
    }, []);

    //searchUserInformation
    const searchUserInformationAction = async (text = serachUservalue) => {
        if (text.trim().length > 0) {
            setSpining(true);
            const response = await searchUserInformation(text.trim());
            const tempSearchUserInformations = response?.filter(users => users.mail != null && users.mail !== '');
            setSearchUserInformations(tempSearchUserInformations);
            setSpining(false);
        }
    };

    //searchUserInformation for delete
    const searchUserInformationForDeleteAction = async () => {
        setSpining(true);
        const response = await getAgriAlertAdminPublisherUsers();
        setSearchUserInformationsForDelete(response.data);
        setSpining(false);
    };

    const [doudong, setDoudong] = useState(null);
    const onSearchs = async (value: string) => {
        setSerachUservalue(value);
        if (value != '') {
            clearTimeout(doudong);
            const time = setTimeout(() => {
                searchUserInformationAction(value);
                setDoudong(null);
            }, 800);
            setDoudong(time);
        } else {
            clearTimeout(doudong);
            setChildrenSelect([]);
        }
    };

    //option
    const [childrenSelect, setChildrenSelect] = useState<React.ReactNode[]>([]);
    useEffect(() => {
        const tmpChirdern: React.ReactNode[] = [];
        console.log('searchUserInformations', searchUserInformations);
        searchUserInformations.forEach((item, index) => {
            tmpChirdern.push(<Option key={index} value={item.displayName}>{item.displayName}</Option>);
        });
        setChildrenSelect(tmpChirdern);
    }, [searchUserInformations]);

    //delete user option
    const [searchUserInformationsForDelete, setSearchUserInformationsForDelete] = useState([]);
    const [childrenSelectForDelete, setChildrenSelectForDelete] = useState<React.ReactNode[]>([]);
    useEffect(() => {
        const tmpChirdern: React.ReactNode[] = [];
        console.log('searchUserInformations', searchUserInformationsForDelete);
        searchUserInformationsForDelete.forEach((item, index) => {
            tmpChirdern.push(<Option key={item.userId} value={item.userDisplayName}>{item.userDisplayName}</Option>);
        });
        setChildrenSelectForDelete(tmpChirdern);
    }, [searchUserInformationsForDelete]);

    //addUsers API
    const addUsersActionU = async () => {
        if(userID==='' ||selectedRole===null){
            dispatch(updateWarningMessage('Please enter the required field'));
            return;
        }
        else{
            const objs = searchUserInformations.find(item => item.displayName == displayName);
            console.log('add ', objs);
            // IUserManagementAddUsersRequestModel
            const addUserParam: IUserManagementAddUsersRequestModel = {
                userID: userID,
                email: mail,
                displayName:displayName,
                roleID: roleID,
                firstName: objs?.givenName,
                lastName: objs?.surname,
                module:'agri alert'
            };
            const response = await addUsers(addUserParam);
            console.log('addUsersActionUaddUsersActionUaddUsersActionU', response);
            if (response === 'Success') {
                setRefreshFlag(refreshFlag + 1);
                dispatch(updateSuccessMessage('New user added succesfully'));
                sendInvitationEmail && sendWelcomeEmailListU();
            }
            if (response === 'This user already exists.') {
                dispatch(updateWarningMessage('This user already exists.'));
            }
            dispatch(addUsersAction({
                userList: [], downloadUserLists: [], deleteFileBoolean: true,
                searchUserInformations: [], addUserList: response, sendWelcomeEmailList: [], updateUserList: []
            }));
            onClose();
        }
    };
    const sendWelcomeEmailListU = async () => {
        // IUserManagementeSendWelcomeEmailrRequestModel
        const sendWelcomeEmailParam: IUserManagementeSendWelcomeEmailrRequestModel = { userEmail: mail, userFirstName: givenName,module:'agri alert' };
        const response = await sendWelcomeEmail(sendWelcomeEmailParam);
        dispatch(sendWelcomeEmailListAction({
            userList: [], downloadUserLists: [], deleteFileBoolean: true,
            searchUserInformations: [], addUserList: [], sendWelcomeEmailList: response, updateUserList: []
        }));
    };
    //updateUser
    const updateUserU = async () => {
        setSpining(true);
        const updateUserParam: IUserManagementeUpdateUserRequestModel = { userID: userIDUpdate, roleID: roleIDUpdate, userIsActive: userIsActiveUpdate ,module:'agri alert'};
        const response = await updateUser(updateUserParam);
        console.log('updateUserupdateUserupdateUser', response);
        if (response === 'Success') {
            setRefreshFlag(refreshFlag + 1);
            if(currentUserId===userIDUpdate){
                if(roleIDUpdate===4){
                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                    setTimeout(()=>{
                        dispatch(updateCurrentRoleId(Number(roleIDUpdate)));
                    },100);
                    dispatch(updateTab(Number(1)));
                    navigate('/agrialert/template');
                }
                if(roleIDUpdate===3){
                    dispatch(updateTemplateType(TemplateEnumType.LISTTEMPLATE));
                    setTimeout(()=>{
                        dispatch(updateCurrentRoleId(Number(roleIDUpdate)));
                    },100);
                    dispatch(updateTab(Number(3)));
                    navigate('/agrialert/template');
                }
                if(roleIDUpdate===1){
                    setTimeout(()=>{
                        dispatch(updateCurrentRoleId(Number(roleIDUpdate)));
                    },100);
                    dispatch(updateTab(Number(1)));
                }
            }
            dispatch(updateSuccessMessage('User data has been changed'));
            setSpining(false);
        }else{
            dispatch(updateSuccessMessage('User data change failed'));
            setSpining(false);
        }
        dispatch(updateUserAction({
            userList: [], downloadUserLists: [], deleteFileBoolean: true,
            searchUserInformations: [], addUserList: [], sendWelcomeEmailList: [], updateUserList: response
        }));
    };
    //deleteUser
    const [isShowSubscriText,setIsShowSubscriText]=useState<boolean>(false);
    const deleteUser = async () => {
        const updateUserParam: IUserManagementeDeleteUserRequestModel = { selectedUserIDs: userIDUpdate};
        console.log('666delete:',updateUserParam);
        const checkIsHaveTemp=await checkIfUserHaveTemplate(userIDUpdate);
        const checkIsHaveSubscriptions=await checkIfUserHaveSubscription(userIDUpdate);
        setIsShowSubscriText(checkIsHaveSubscriptions);
        if(checkIsHaveTemp){
            setOpen(false);
            setConfirmOpen(true);
        }else{
            setOpen(false);
            setOpenRemove(true);
            const response = await deleteAgriAlertUsers(updateUserParam);
            if (response === 'Success') {
                setRefreshFlag(refreshFlag + 1);
            }
            dispatch(updateUserAction({
                userList: [], downloadUserLists: [], deleteFileBoolean: true,
                searchUserInformations: [], addUserList: [], sendWelcomeEmailList: [], updateUserList: response
            }));
        }
    };
    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => handleScroll());
        return () => window.removeEventListener('scroll', () => handleScroll());
    }, []);
    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50) {
            console.log('fech more items', pageIndex);
            setIsFetching(true);
        } else {
            console.log('unreach');
        }
    };
    useEffect(() => {
        if (!isFetching) return;
        setpageIndex(pageIndex + 1);
        getUserLists(searchText, pageIndex + 1);
    }, [isFetching]);

    //delete
    const [open, setOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [removeOpen, setOpenRemove] = useState(false);
    //modal1
    const showModal = () => {
        setOpen(true);
    };

    const hideModal = () => {
        setOpen(false);
    };
    //modal2
    const showConfirmModal = () => {
        setConfirmOpen(true);
    };

    const hideConfirmModal = () => {
        setConfirmOpen(false);
    };
    //If there is template(s) created by this user,delete directly
    const deleteuserOnclick = () => {
        deleteUser();
        setConfirmOpen(false);
        setOpen(false);
        setVisible2(false);
    };
    //modal3
    const showRemoveModal = () => {
        setOpenRemove(true);
    };

    const confirmDelete= async()=>{
        const updateUserParam: IUserManagementeDeleteUserRequestModel = { selectedUserIDs: userIDUpdate};
        console.log('rrrr:',userIDForDelete);
        if(userIDForDelete){
            const transRes=await transferTemplatesToUser({
                deleteUserId: userIDUpdate,
                transferUserId: userIDForDelete,
            });
            if(transRes=='Success'){
                const response = await deleteAgriAlertUsers(updateUserParam);
                if(response==='Success'){
                    setConfirmOpen(false);
                    setOpenRemove(true);
                    setRefreshFlag(refreshFlag + 1);
                }
                dispatch(updateUserAction({
                    userList: [], downloadUserLists: [], deleteFileBoolean: true,
                    searchUserInformations: [], addUserList: [], sendWelcomeEmailList: [], updateUserList: response
                }));
            }
        }else{
            dispatch(updateWarningMessage('Please select a person'));
        }
    };

    const hideRemoveModal = () => {
        setOpenRemove(false);
        setConfirmOpen(false);
        setOpen(false);
    };
    return (
        <div ref={home} className="agrialert-user-management-content" style={{ width: '100%', height: '640px' }}>
            <div
                className="site-layout-background"
            >
                {/* Drawer: New User */}
                <Drawer
                    placement="right"
                    closeIcon={null}
                    open={visible}
                    style={{ overflow: 'hidden' }}>
                    <Form
                        id="Form"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ marginTop: '20px' }}
                        form={form}
                    >
                        <div className='header-div'>
                            <label>Add User</label>
                        </div>
                        <Form.Item style={{ marginBottom: '10px', fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Designation" required>
                            <Select
                                size='large'
                                placeholder="Role of the User"
                                style={{ flex: 1 }}
                                onChange={callback}
                                value={selectedRole}
                                options={[
                                    { value: 3, label: 'Reader' },
                                    { value: 4, label: 'Publisher' },
                                    { value: 1, label: 'Administrator' },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: '10px', fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Name" required>
                            <Spin spinning={spining}>
                                <Select
                                    size='large'
                                    showSearch
                                    placeholder="Select a person"
                                    optionFilterProp="children"
                                    value={displayName}
                                    onChange={onChanges}
                                    onSearch={onSearchs}
                                    onBlur={e => setChildrenSelect([])}
                                >
                                    {childrenSelect}
                                </Select>
                            </Spin>
                        </Form.Item>
                        <Form.Item
                            label="Mail ID"
                            style={{ fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                        >
                            <Input size='large' placeholder="user.name@domain.com" value={mail} disabled /><span style={{ display: 'none' }}>{mail}</span>
                        </Form.Item>
                    </Form>
                    <Checkbox onChange={onChangeSend} checked={sendInvitationEmail}>
                        <span style={{ color: '#696F88' }}>Send invitation email</span>
                    </Checkbox>
                    <Form style={{ marginTop: '40px', float: 'right' }}>
                        <Button
                            onClick={onClose}
                            size='large'
                            style={{ margin: '0 10px', borderRadius: '24px' }}>Cancel</Button>
                        <Button
                            type="primary"
                            onClick={addUsersActionU}
                            size='large'
                            style={{
                                background: '#59B948',
                                borderRadius: '24px',
                                border: '1px solid #59B948'
                            }}>
                            Save
                        </Button>
                    </Form>
                </Drawer>
                {/* Drawer:Edit User */}
                <Drawer
                    placement="right"
                    closeIcon={null}
                    open={visible2}
                    style={{ overflow: 'hidden' }}>
                    <Form
                        id="Form"
                        name="basic"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ marginTop: '20px' }}
                    >
                        <div className='header-div'>
                            <label>Edit User</label>
                            <Button onClick={showModal}>Delete User</Button>
                        </div>
                        <Form.Item style={{ marginBottom: '10px', fontWeight: 400, color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Designation">
                            <Select
                                size='large'
                                placeholder="Role of the User"
                                onChange={callbackEdit}
                                value={newRoleIDUpdate}
                                style={{ flex: 1 }}
                                options={[
                                    { value: 3, label: 'Reader' },
                                    { value: 4, label: 'Publisher' },
                                    { value: 1, label: 'Administrator' },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: '10px', color: '#14151C', fontFamily: 'Noto-Sans-Regular' }}
                            label="Name"
                            name="name"
                        >
                            <Input size='large' placeholder="user.name" value={userDisplayNameUpdate} disabled /><span style={{ display: 'none' }}>{userDisplayNameUpdate}</span>
                        </Form.Item>
                        <Form.Item
                            label="Email ID"
                            name="email"
                        >
                            <Input size='large' placeholder="user.name@domain.com" value={userEmailUpdate} disabled /><span style={{ display: 'none' }}>{userEmailUpdate}</span>
                        </Form.Item>
                    </Form>
                    <Form.Item label="Status">
                        <Radio.Group name="radiogroup" value={tabPosition} onChange={changeTabPosition}>
                            <Radio value="true"> Active </Radio>
                            <Radio value="false"> Inactive </Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form style={{ marginTop: '40px', float: 'right' }}>
                        <Button
                            onClick={onClose2}
                            size='large'
                            style={{ margin: '0 10px', borderRadius: '24px' }}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={success2}
                            size='large'
                            style={{
                                background: '#59B948',
                                borderRadius: '24px',
                                border: '1px solid #59B948'
                            }}>
                            Save
                        </Button>
                    </Form>
                </Drawer>
                <h3 className='soliHeader'>
                    User Management
                </h3>
                {/* Search and addUser */}
                <div className='management-search-div'>
                    <div>
                        <HeaderSearchAgrialert GetAnalyses={searchKeyDown} placeholder='Search' />
                    </div>
                    <div className='add-btn-div'>
                        <Button
                            icon={<PlusOutlined />}
                            className='add-btn-style'
                            onClick={showDrawer}>
                            Add New User
                        </Button>
                    </div>
                </div>
                <div className="user-table-div">
                    <Table
                        // scroll={{y: 320 }}
                        pagination={false}
                        columns={columns}
                        dataSource={userList}
                    />
                </div>
                {/* isDelete popup */}
                <Modal
                    open={open}
                    onOk={hideModal}
                    onCancel={hideModal}
                    // okText="Delete"
                    cancelText="Cancel"
                    width={808}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={hideModal}>
                            Cancel
                            </Button>
                            <Button type="primary" onClick={deleteuserOnclick}>
                            Delete
                            </Button>
                        </div>
                    }
                >  <AgrialertUserManagementDeleteSvg />
                    <p className='first-line-style'>Are you sure you want to remove <br />
                        <span className='second-line-style'>{userDisplayNameUpdate} from the User List?</span></p>
                </Modal>
                {/*  if the user have templates,pop-up */}
                <Modal
                    open={confirmOpen}
                    width={708}
                    onOk={hideConfirmModal}
                    onCancel={hideConfirmModal}
                    okText="Delete"
                    cancelText="Cancel"
                    closable={false}
                    className='confirm-delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={hideConfirmModal}>
                            Cancel
                            </Button>
                            <Button type="primary" onClick={confirmDelete}>
                            Confirm
                            </Button>
                        </div>
                    }>
                    <AgrialertUserManagementDeleteSvg />
                    <p className='first-line-style'>Before removing the user premanently <br />
                        <span className='second-line-style'>assign the template to another user</span></p>
                    <div style={{width:'80%',margin:'0 auto'}}>
                        <div style={{textAlign:'left',marginBottom:'10px'}}>
                            <p>Name</p>
                            <Select
                                style={{width:'100%'}}
                                size='large'
                                showSearch
                                placeholder="Select a person"
                                onChange={onChangesForDelete}
                            >
                                {childrenSelectForDelete}
                            </Select>
                        </div>
                        <div style={{textAlign:'left',marginTop:'10px'}}>
                            <p>Email ID</p>
                            <Input size='large' placeholder="user.name@domain.com" value={mailForDelete} disabled /><span style={{ display: 'none' }}>{mail}</span>
                        </div>
                        <IF show={isShowSubscriText}>
                            <p style={{color:'red'}}>All the subscriptions created by the User will be deleted</p>
                        </IF>
                    </div>
                </Modal>
                {/* 3 */}
                <Modal
                    open={removeOpen}
                    width={708}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={hideRemoveModal}>
                            Close
                            </Button>
                        </div>
                    }
                >
                    <AgrialertUserManagementSuccessSvg />
                    <p className='second-line-style'>&apos;{userDisplayNameUpdate}&apos;<br />
                        <span className='first-line-style'>has been removed from the list Successfully</span></p>
                </Modal>
            </div>
        </div>
    );
}
